module.exports = __webpack_public_path__ + "img/australia-congenital-and-perinatal-diseases-female.17c281f8.png";